<script>
import ModuleTitle from '../common/ModuleTitle.vue'
import Module30Item from '../content/Module30Item.vue'

export default {
  name: 'Comp30',
  components: { ModuleTitle, Module30Item },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  }
}
</script>

<template>
  <div class="modules-id-30">
    <module-title :title="moduleOption.title" margin-bottom="28" />
    <div class="comp-transverse-2 modules-id-30-content pointer">
      <p class="subtitle">{{ moduleOption.subtitle }}</p>
      <div class="right-list">
        <module30-item
          v-for="(v, i) in moduleOption.list.slice(0, 3)"
          :key="`modules-30-${i}`"
          :memo="v.memo"
          :name="v.name"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-30-content {
  // width: 100%;
  // height: 100%;
  display: flex;
}
.subtitle {
  width: 48px;
  height: 180px;
  writing-mode: vertical-rl;
  font-size: 16px;
  font-family: siyuansong;
  font-weight: 800;
  color: #CC0A66;
  letter-spacing: 2px;
  background: url('~imgs/modules/id-30-subtitle.png') no-repeat center;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.right-list {
  display: flex;
  column-gap: 20px;
  margin-left: 35px;
  .item {
    width: 196px;
    height: 325px;
    background: url('~imgs/modules/id-30-bg.png') no-repeat center;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 20px;
    box-sizing: border-box;
    .item-name {
      height: 285px;
      text-align: end;
      writing-mode: vertical-lr;
      font-size: 16px;
      font-family: siyuansong;
      font-weight: 800;
      color: #CC0A66;
      letter-spacing: 2px;
      margin-left: 14px;
    }
    .item-content {
      // width: 140px;
      height: 255px;
      font-size: 11px;
      font-weight: bold;
      color: #000;
      writing-mode: vertical-lr;
      letter-spacing: 1px;
      margin-left: 14px;
    }
  }
}
</style>
